import React from 'react';
import { Link } from 'react-router-dom';
import SectorPage from '../components/SectorPage';
import Ticker from '../components/Ticker';

const SERIF = "'Newsreader', Georgia, serif";
const GOLD  = '#c79a3a';
const SELF  = '/coverage/government';

function SponsoredBand() {
  return (
    <div style={{ background: '#0d2235', marginTop: 34 }} data-testid="gov-sponsored-band">
      <div className="container-custom">
        <div style={{ padding: '20px 0' }}>
          <div style={{ fontSize: 9, letterSpacing: '1.3px', textTransform: 'uppercase', color: '#5f7b8e', fontWeight: 700, marginBottom: 14 }}>Sponsored</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 28, flexWrap: 'wrap' }}>
            <div style={{ flexShrink: 0 }}>
              <svg width="68" height="78" viewBox="0 0 68 78" fill="none" aria-hidden="true">
                <path d="M34 4 L62 14 L62 44 Q62 64 34 74 Q6 64 6 44 L6 14 Z" fill="#1a3a70" stroke={GOLD} strokeWidth="2.5"/>
                <path d="M34 12 L56 20 L56 44 Q56 60 34 68 Q12 60 12 44 L12 20 Z" fill="#1e4490" stroke={GOLD} strokeWidth="1.2"/>
                <circle cx="34" cy="40" r="14" fill="#1a3a70" stroke={GOLD} strokeWidth="1.5"/>
                <text x="34" y="38" textAnchor="middle" fontFamily="sans-serif" fontSize="8" fontWeight="700" fill={GOLD} letterSpacing=".5">FLORIDA</text>
                <text x="34" y="48" textAnchor="middle" fontFamily="sans-serif" fontSize="7" fontWeight="700" fill="#fff">POLICE</text>
                <polygon points="34,14 35.6,19 40.5,19 36.5,22 37.8,27 34,24 30.2,27 31.5,22 27.5,19 32.4,19" fill={GOLD}/>
              </svg>
            </div>
            <div style={{ flex: '1 1 0', minWidth: 260 }}>
              <h2 style={{ fontFamily: SERIF, fontWeight: 500, fontSize: 28, lineHeight: 1.1, margin: '0 0 6px', color: '#fff' }}>Florida Police Department is Hiring</h2>
              <p style={{ fontSize: 13, color: '#8aa4b8', margin: 0 }}>Serve your community. Build a career. Make a difference.</p>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
              {[
                { label: 'Competitive Pay & Benefits', icon: <svg width="32" height="32" viewBox="0 0 36 36" fill="none" stroke="#7fafc0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="18" cy="18" r="13"/><path d="M18 10v8M18 10v8l5 3"/></svg> },
                { label: 'Career Growth Opportunities', icon: <svg width="32" height="32" viewBox="0 0 36 36" fill="none" stroke="#7fafc0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="18" cy="12" r="6"/><path d="M8 30c0-6 4.5-10 10-10s10 4 10 10"/><polyline points="22,10 26,6 30,10"/></svg> },
                { label: 'Tuition Assistance & Training', icon: <svg width="32" height="32" viewBox="0 0 36 36" fill="none" stroke="#7fafc0" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M18 4l12 6v8c0 7-5 13-12 15C11 31 6 25 6 18v-8z"/><path d="M13 17l3.5 3.5 7-7"/></svg> },
              ].map((item, i) => (
                <div key={i} style={{ textAlign: 'center' }}>
                  <div style={{ display: 'block', margin: '0 auto 7px' }}>{item.icon}</div>
                  <div style={{ fontSize: 11, fontWeight: 600, color: '#c5d8e5', maxWidth: 72, lineHeight: 1.3 }}>{item.label}</div>
                </div>
              ))}
              <Link to={SELF} style={{ background: GOLD, color: '#fff', padding: '12px 22px', borderRadius: 4, fontWeight: 700, fontSize: 14, textDecoration: 'none', whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: 10, marginLeft: 8 }} data-testid="gov-sponsored-apply">
                Apply Now&nbsp;→
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const GOVERNMENT_CONFIG = {
  slug: 'government',
  label: 'Government',
  selfPath: SELF,
  heroSlug: 'coverage/government',
  h1Text: 'Government',
  h1Subtitle: 'Serving the public. Strengthening policy. Building infrastructure. Driving opportunity for all.',
  h1Body: 'Independent reporting and smart analysis on policy, agencies, civic leadership, public services, and the systems that power communities.',
  briefingCtaText: "Read Today's Government Briefing",
  storiesCtaText: 'Explore Government Briefings',
  storiesAnchorId: 'sp-stories',
  gridLabel: 'Government Briefings',
  testId: 'government-page',
  rightRailWidgets: [
    { type: 'video_of_week', duration: '6:02', title: 'Building Trust in Government', description: 'How transparency, data, and citizen engagement can strengthen democracy.' },
    { type: 'in_focus', label: 'Agency Spotlight', name: 'U.S. Dept. of Transportation', description: 'Leading the way on safer transportation, infrastructure, and community investment.', badgeInitials: 'DOT', badgeBg: '#16304a', badgeColor: '#c79a3a' },
    { type: 'executive_spotlight', initials: 'JB', name: 'Jennifer Brown', title: 'Administrator, GSA', description: 'Driving smarter government through technology, sustainability, and better services.' },
    { type: 'cta_pair' },
    { type: 'leaving_soon' },
    { type: 'first_round_promo' },
  ],
};

export default function GovernmentPage() {
  return (
    <SectorPage
      config={GOVERNMENT_CONFIG}
      PulseBar={() => <Ticker scope="government" />}
      SponsoredBand={SponsoredBand}
    />
  );
}
